import {Directive, Input, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[jdCustomLabelOutlet]'
})
export class CustomLabelOutletDirective {

  @Input() jdCustomLabelOutlet: string;

  constructor(public viewContainerRef: ViewContainerRef) { }

}
